export default __webpack_public_path__ + "static/media/promo-login.973ce700.svg";